import React from 'react';
import { AddressWithDetails } from '@dr-pam/common-components/Services/GoogleMapsService';
import { IconWifi } from '@tabler/icons-react';

export type PublicProfile = {
	id: string;
	publicName: string;
	publicDiscipline: string;
	publicAddress: AddressWithDetails;
	publicIsTelehealthAvailable: boolean;
	distanceKm?: number;
};

export type PractitionerProps = {
	className?: string;
	profile: PublicProfile;
	onClick?: () => void;
};

export default function Practitioner(props: PractitionerProps) {
	const { className, profile, onClick } = props;

	const publicAddress = profile.publicAddress;

	const address = (
		<p className="address">
			{!publicAddress.address.startsWith(publicAddress.name) && `${publicAddress.name}\n`}
			{publicAddress.address}
			{profile.distanceKm === undefined
				? ''
				: `\n(${profile.distanceKm.toLocaleString(undefined, { maximumFractionDigits: 1 })} km from you)`}
		</p>
	);
	const telehealth = profile.publicIsTelehealthAvailable ? (
		<p className="telehealth">
			<IconWifi size={16} /> Available for online appointments
		</p>
	) : null;

	const phone = publicAddress.phone ? (
		<p className="phone">
			<strong>Phone:</strong> <a href={`tel:${publicAddress.phone}`}>{publicAddress.phone}</a>
		</p>
	) : null;

	const email = publicAddress.email ? (
		<p className="email">
			<strong>Email:</strong> <a href={`mailto:${publicAddress.email}`}>{publicAddress.email}</a>
		</p>
	) : null;

	const website = publicAddress.website ? (
		<p className="website">
			<strong>Web:</strong>{' '}
			<a
				href={`${publicAddress.website.startsWith('http') ? '' : 'http://'}${publicAddress.website}`}
				target="_blank"
				rel="noopener noreferrer"
			>
				{publicAddress.website}
			</a>
		</p>
	) : null;

	return (
		<div className={`Practitioner ${className ?? ''}`} onClick={onClick}>
			<p>
				<span className="name">{profile.publicName}</span>{' '}
				<span className="discipline">({profile.publicDiscipline})</span>
			</p>
			{telehealth}
			{address}
			{phone}
			{email}
			{website}
		</div>
	);
}
